<mat-dialog-content cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".root" (cdkDragStarted)="dragStart($event)"
  (cdkDragMoved)="dragMoved($event)">
  <div id="video-container" [ngClass]="{'fullscreen': isFullScreen}">
    <video #videoElem width="100%" autoplay="autoplay" disablePictureInPicture controlsList="nodownload nofullscreen" webkit-playsinline="true" playsinline="true"></video>
    <div>
      @if (!isFullScreen) {
        <div class="secondary-button">
          @if (supportFullScreen) {
            <button class="controls" (click)="requestFullScreen()">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <title>expand</title>
                <g fill="none" fill-rule="evenodd">
                  <g fill="#FFF" fill-rule="nonzero">
                    <path d="M201.667 526l2.044 2.044-2.569 2.552 1.262 1.262 2.552-2.57 2.044 2.045V526h-5.333zM191 531.333l2.044-2.044 2.552 2.569 1.262-1.262-2.57-2.552 2.045-2.044H191v5.333zM196.333 542l-2.044-2.044 2.569-2.552-1.262-1.262-2.552 2.57-2.044-2.045V542h5.333zM207 536.667l-2.044 2.044-2.552-2.569-1.262 1.262 2.57 2.552-2.045 2.044H207v-5.333z" transform="translate(-191 -526)"/>
                  </g>
                </g>
              </svg>
            </button>
          }
          <button class="controls" (click)="toggleVolume()" [disabled]="!hasAudio">
            @if (!isVideoMuted) {
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16">
                <title>mute</title>
                <g fill="none" fill-rule="evenodd">
                  <g fill="#FFF">
                    <path d="M237.342 526.066c.337.137.558.46.56.82v14.237c-.006.356-.225.674-.558.81-.333.136-.716.062-.973-.187l-4.249-4.182H228.9c-.497 0-.9-.399-.9-.89v-5.339c0-.491.403-.89.9-.89h3.231l4.23-4.182c.257-.255.644-.333.981-.197zm6.023 1.648c3.513 3.474 3.513 9.107 0 12.581-.357.303-.89.282-1.222-.046-.333-.33-.353-.855-.047-1.208 1.352-1.336 2.111-3.147 2.111-5.037 0-1.889-.76-3.7-2.111-5.036-.306-.353-.286-.88.047-1.208.332-.328.865-.349 1.222-.046zm-2.548 2.518c2.106 2.084 2.106 5.46 0 7.545-.357.302-.89.282-1.222-.047-.332-.328-.353-.854-.047-1.208.676-.667 1.056-1.573 1.056-2.518 0-.944-.38-1.85-1.056-2.518-.257-.217-.369-.559-.29-.884.08-.325.336-.578.665-.657.329-.078.674.033.894.287z" transform="translate(-228 -526)"/>
                  </g>
                </g>
              </svg>
            } @else {
              <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>un-mute</title>
                <g id="page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="mute" fill="#FFFFFF" fill-rule="nonzero">
                    <path d="M12,0.565538541 C12,0.351630704 11.8740458,0.148981174 11.6793893,0.0589147159 C11.4732824,-0.0424100491 11.2442748,-0.00863512743 11.0725191,0.126464559 L6,4.10064701 L12,10 L12,0.565538541 L12,0.565538541 Z" id="Path"></path>
                    <path d="M15.8328512,15.0240174 L0.975177685,0.167139873 C0.752312583,-0.0557132908 0.390013929,-0.0557132908 0.167148827,0.167139873 C-0.0557162756,0.389993036 -0.0557162756,0.752272281 0.167148827,0.975125444 L3.76270581,4.57163265 L3.42783671,4.57163265 C3.07353834,4.57163265 2.76495589,4.73162979 2.55923426,4.98305387 C2.38779956,5.17733612 2.28493875,5.44018857 2.28493875,5.71446938 L2.28493875,10.2858163 C2.28493875,10.9143765 2.79924283,11.4286531 3.42783671,11.4286531 L6.07935998,11.4286531 L11.645273,15.874288 C11.7481339,15.9542865 11.8738526,16 11.9995714,16 C12.0795743,16 12.1710061,15.9771433 12.251009,15.9428582 C12.4453016,15.8514312 12.5710204,15.6457206 12.5710204,15.4285816 L12.5710204,13.3794754 L15.0236794,15.832003 C15.1356834,15.944001 15.2819744,16 15.4282653,16 C15.5745562,16 15.7208472,15.944001 15.8328512,15.8331458 C16.0557163,15.6091498 16.0557163,15.2480134 15.8328512,15.0240174 Z" id="Path"></path>
                  </g>
                </g>
              </svg>
            }
          </button>
        </div>
        <div>
          <button class="controls controls-close" (click)="close('pip')">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
              <title>close</title>
              <defs>
                <path id="vmdpr6xrva" d="M13.964.873l1.182 1.182L9.192 8.01l5.954 5.955-1.182 1.182L8.01 9.192l-5.955 5.954-1.182-1.182 5.954-5.955L.873 2.055 2.055.873 8.01 6.827 13.964.873z"/>
              </defs>
              <g fill="none" fill-rule="evenodd">
                <g>
                  <g transform="translate(-328 -526) translate(328 526)">
                    <mask id="corjlqp1kb" fill="#fff">
                      <use xlink:href="#vmdpr6xrva"/>
                    </mask>
                    <g fill="#FFF" mask="url(#corjlqp1kb)">
                      <path d="M0 0H16V16H0z"/>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </button>
        </div>
      }

      @if (isFullScreen) {
        <button class="controls controls-close" (click)="_exitFullScreen()">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 16 16">
            <title>close</title>
            <defs>
              <path id="vmdpr6xrva" d="M13.964.873l1.182 1.182L9.192 8.01l5.954 5.955-1.182 1.182L8.01 9.192l-5.955 5.954-1.182-1.182 5.954-5.955L.873 2.055 2.055.873 8.01 6.827 13.964.873z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
              <g>
                <g transform="translate(-328 -526) translate(328 526)">
                  <mask id="corjlqp1kb" fill="#fff">
                    <use xlink:href="#vmdpr6xrva"/>
                  </mask>
                  <g fill="#FFF" mask="url(#corjlqp1kb)">
                    <path d="M0 0H16V16H0z"/>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </button>
      }
    </div>
  </div>
</mat-dialog-content>